import React from 'react';
import ExpandableCallout from '../../../components/playbooks/ExpandableCallout';
import PlaybookHeading from '../../../components/playbooks/PlaybookHeading';

const ManagerCommunityStage2 = () => {
  return (
    <div className="max-w-none text-gray-100">
      <PlaybookHeading
        title="Stage 2: Mobilising"
        subtitle="Share the memo and get alignment from people managers on the community of practice."
      />
      
      <ExpandableCallout
        type="info"
        title="What do I need to DO in this stage?"
        defaultOpen={true}
      >
        <p className="text-base text-gray-300 leading-relaxed">
          You need to do 3 things:
        </p>
        <ol className="list-none space-y-2 text-gray-300">
          <li className="flex items-start">
            <span className="text-primary-light font-bold mr-2">1.</span>
            <span>Share the memo you built in previous stage for async discussion with the other people managers</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light font-bold mr-2">2.</span>
            <span>Gauge appetite and alignment to kick-off the community of practice</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light font-bold mr-2">3.</span>
            <span>Facilitate a call with people managers to align on next steps</span>
          </li>
        </ol>
        <p className="mt-4 text-base text-gray-300 leading-relaxed">Here's what we mean…</p>
      </ExpandableCallout>

      <div className="mt-8 space-y-6">
        <h2 className="text-xl font-semibold text-white mb-4">Getting Alignment: Sharing The Memo</h2>
        <p className="text-base text-gray-300 leading-relaxed">
          In the previous stage we identified a people manager as an Angel Of Change. Here's a great place for you to lean on them.
        </p>
        <p className="text-base text-gray-300 leading-relaxed">
          You can ask them to bring the idea of a people manager community of practice to the rest of their peers or you can do it together.
        </p>
        <p className="text-base text-gray-300 leading-relaxed">
          We're big Notion fans and find that it's a good medium for this.
        </p>

        <h3 className="text-lg font-semibold text-white mb-3">Action:</h3>
        <ol className="list-none space-y-2 text-gray-300">
          <li className="flex items-start">
            <span className="text-primary-light font-bold mr-2">1.</span>
            <span>Share memo (notion 1 pager) with people managers and invite them to:</span>
            <ul className="list-none space-y-2 ml-6 mt-2">
              <li className="flex items-start">
                <span className="text-primary-light mr-2">—</span>
                <span>comment questions/thoughts/improvements</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-light mr-2">—</span>
                <span>indicate whether they are 'for' or 'against' a people manager community of practice (if against invite them to offer alternative proposal)</span>
              </li>
            </ul>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light font-bold mr-2">2.</span>
            <span>Give a timeframe (async) for commentary - I'd usually suggest 2-3 days.</span>
          </li>
          <li className="flex items-start">
            <span className="text-primary-light font-bold mr-2">3.</span>
            <span>Respond to all comments async</span>
          </li>
        </ol>

        <ExpandableCallout
          type="tip"
          title="Watch and Listen"
          defaultOpen={true}
        >
          <p className="text-base text-gray-300 leading-relaxed">
            You'll be able to gauge sentiment from the tone of these comments and start to get a feel for: "is this going to be an uphill struggle" or "yes, this is what folks want"
          </p>
          <p className="text-base text-gray-300 leading-relaxed">
            If you aren't getting the internet-head-nods you hoped for it might be time to reset and look at alternate options with the group.
          </p>
        </ExpandableCallout>
      </div>

      <div className="mt-8 space-y-6">
        <h2 className="text-xl font-semibold text-white mb-4">Arrange The Kick-Off Call</h2>
        <p className="text-base text-gray-300 leading-relaxed">
          If the memo got head nods and "hell yeahs!", we can get started. Good job! 🎉
        </p>
        <p className="text-base text-gray-300 leading-relaxed">
          Would recommend inviting all people managers to a 45min call (sync) with the aim of:
        </p>

        <h3 className="text-lg font-semibold text-white mb-3">Community Design</h3>
        <p className="text-base text-gray-300 leading-relaxed">
          Think of this like a team charter session but for the people manager community of practice. More on that in the next stage.
        </p>
      </div>
    </div>
  );
};

export default ManagerCommunityStage2; 